if (!customElements.get('yam-loyalty-points')) {
  customElements.define('yam-loyalty-points', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('product-info') || this.closest('section');
      this.description = this.querySelector('[data-yam-loyalty-description]');
      if (!this.root || !this.description) return;
      this.schedule = () => {
        if (this.pending) return;
        this.pending = true;
        queueMicrotask(() => {
          this.pending = false;
          if (this.isConnected) this.updatePoints();
        });
      };
      this.observer = new MutationObserver(this.schedule);
      this.observer.observe(this.root, {childList: true, subtree: true, characterData: true});
      this.root.addEventListener('change', this.schedule);
      this.updatePoints();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.root?.removeEventListener('change', this.schedule);
    }
    updatePoints() {
      const prices = [...this.root.querySelectorAll('.variant-option-button-label__price')]
        .filter(node => !node.closest('product-info') || node.closest('product-info') === this.root)
        .map(node => {
          const text = [...node.childNodes].filter(child => child.nodeType === 3 || (child.nodeType === 1 && !child.classList.contains('visually-hidden') && child.tagName !== 'S')).map(child => child.textContent).join('');
          return this.parseCents(text);
        }).filter(price => Number.isFinite(price) && price > 0);
      const nativePrice = Number(this.dataset.nativeMaxPrice);
      const highestPrice = prices.length ? Math.max(nativePrice, ...prices) : Number(this.dataset.fallbackPrice);
      const points = Math.floor(highestPrice / 10);
      if (!Number.isFinite(points) || points < 0) return;
      const text = this.dataset.description.replace(/&#39;/g, "'").replace(/&quot;/g, '"').replace(/&amp;/g, '&').replace('__POINTS__', String(points));
      if (this.description.textContent !== text) this.description.textContent = text;
    }
    parseCents(text) {
      let value = text.replace(/[^\d.,]/g, '');
      if (!value) return NaN;
      const separator = Math.max(value.lastIndexOf(','), value.lastIndexOf('.'));
      if (separator >= 0 && value.length - separator - 1 === 2) {
        value = value.slice(0, separator).replace(/[.,]/g, '') + '.' + value.slice(separator + 1);
      } else {
        value = value.replace(/[.,]/g, '');
      }
      return Math.round(Number(value) * 100);
    }
  });
}
